import { z } from "zod";

export const contactSchema = z.object({
  firstName: z.string().min(1, "First name is required").refine((val) => val.replace(/\s/g, '').length >= 3, {
    message: "First name must contain at least 3 letters",
  }),
  lastName: z.string().optional(),
  phoneNumber: z.string()
    .min(10, "Phone number must be 10 digits")
    .max(10, "Phone number must be 10 digits")
    .regex(/^[6-9]\d{9}$/, "Please enter a valid 10-digit mobile number (no 0 or +91)"),
  email: z.string().regex(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email format. E.g. name@example.com").optional().or(z.literal("")),
  addressLine1: z.string().optional().nullable().or(z.literal("")),
  addressLine2: z.string().optional().nullable().or(z.literal("")),
  city: z.string().min(1, "City is required"),
  district: z.string().optional().nullable(),
  state: z.string().min(1, "State is required"),
  pincode: z.string().regex(/^\d{6}$/, "PIN Code must be exactly 6 digits").optional().nullable().or(z.literal("")),
  officeLocation: z.string().optional().nullable(),
  assignedTo: z.string().optional().nullable(),
  referenceType: z.string().optional().nullable(),
  status: z.string().default("new"),
  salesType: z.string().optional().nullable(),
  teleStatus: z.string().optional().nullable(),
  leadStatus: z.string().optional().nullable(),
  referenceDetails: z.string().optional().nullable(),
  customId: z.string().optional().nullable(),
  requirementType: z.string().optional().nullable(),
  propertyType: z.string().optional().nullable(),
  budget: z.number().optional().nullable().or(z.string().transform(v => v === "" ? null : Number(v))),
  notes: z.string().optional().nullable(),
  /*developer: Nithin
    date : 2024-06-19
    changes : Valadating the Date and Alt Date same or not */

  preferredDate: z.string().optional().nullable().or(z.literal("")).refine(val => {
    if (!val) return true;
    const d = new Date();
    const todayStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return val >= todayStr;
  }, { message: "Date cannot be in the past" }),
  alternativeMeetingDate: z.string().optional().nullable().or(z.literal("")).refine(val => {
    if (!val) return true;
    const d = new Date();
    const todayStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return val >= todayStr;
  }, { message: "Alternative date cannot be in the past" }),
  meetingTime: z.string().optional().nullable().or(z.literal("")),
  alternativeMeetingTime: z.string().optional().nullable().or(z.literal("")),
  attendedBy: z.string().optional().nullable(),
  /* Developer: Nithin | Date: 09-07-2026 | Changes: appointmentDate unified field — same as Schedule Appointment, no back dates */
  appointmentDate: z.string().optional().nullable().or(z.literal("")).refine(val => {
    if (!val) return true;
    const d = new Date();
    const todayStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return val >= todayStr;
  }, { message: "⚠️ You are trying to select a past date — invalid! Please select today or a future date." }),
  appointmentTime: z.string().optional().nullable().or(z.literal(""))
}).superRefine((data, ctx) => {
  if (data.preferredDate && data.alternativeMeetingDate && data.preferredDate === data.alternativeMeetingDate) {
    ctx.addIssue({
      path: ["alternativeMeetingDate"],
      message: "Alternative date cannot be the same as Date",
      code: z.ZodIssueCode.custom
    });
  }
});

export const bulkImportSchema = z.array(contactSchema);
